<template>
  <div class="loading-page-box">
    <van-loading size="36px" vertical v-if="!tips" style="padding-top: 50%">加载中...</van-loading>
    <img
      src="../../assets/error404.jpg"
      v-if="tips"
      style="width: 30%; margin-bottom: 10px; padding-top: 50%"
    />
    <div v-if="tips" style="font-size: 24px">{{ tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'preOrder',
  data() {
    return {
      preOrderSn: '',
      tvToken: '',
      relogin: false,
      buyObj: {},
      goodsObj: {},
      buyType: 1,
      goodsNum: null,
      tips: ''
    };
  },
  created() {},
  mounted() {
    const { query } = this.$route;
    console.log('query', query);
    this.preOrderSn = query.preOrderSn;
    // if (relogin) {
    //   // 强制登录 登录返回之后，设置relogin = false
    //   return
    // }
    this.init();
  },
  methods: {
    init() {
      const params = {
        preOrderSn: this.preOrderSn
      };
      this.$service.getPreOrderInfo(params).then((res) => {
        this.buyObj = res.data || {};
        if (res.code === 200) {
          if (res.data.preOrderType === 1) {
            this.buyType = 2;
            this.getGoodsDetail();
          } else if (res.data.preOrderType === 2) {
            this.buyType = 1;
            // 去购物车下单，到下单页
            let goodIds = [];
            this.$service.getCartListNew().then((res) => {
              res.data.forEach((item) => {
                if (item.isSelect === true) {
                  goodIds.push(item.skuId);
                }
              });
            });
            let payParams = {};
            payParams.goodsId = goodIds.toString();
            payParams.buyType = 1; // 购物车渠道结算
            payParams.preOrderSn = this.preOrderSn;
            this.$router.push({ name: 'paying', query: payParams });
          } else if (res.data.preOrderType === 3 && res.data.actType === 1) {
            this.buyType = 3;
            this.getGoodsDetail();
          } else if (res.data.preOrderType === 3 && res.data.actType === 7) {
            this.buyType = 5;
            this.getGoodsDetail();
          }
        } else {
          this.tips = res.message;
        }
      });
    },
    getGoodsDetail() {
      const { skuId } = this.buyObj;
      this.$service
        .getGoodsDetails({
          skuId
        })
        .then((res) => {
          this.goodsObj = res.data;
          // spuType = 1 实物

          // 先判断是否是实物 再判断token
          // 1.虚拟卡必须登录
          // 2.实物 a.有token就获取用户信息 （预防：有token但获取不到用户信息） b.没有token 就重新登录
          // 3.是实物没有token也要登陆
          // 4.是实物 有token 能获取到用户信息 直接跳到下单页 √

          // 是实物
          this.goodsNum = this.buyObj.buyNum === undefined ? 1 : this.buyObj.buyNum;
          if (this.goodsObj.spuType === 1) {
            // 直接跳到下单页，当前的域名 + 下单页的路径 + 参数
            let params = {};
            params.goodsId = this.goodsObj.skuId;
            params.buyType = this.buyType;
            params.number = this.goodsNum;
            params.preOrderSn = this.preOrderSn;
            // 兑换和秒杀获取活动code
            if (this.buyType === 3 || this.buyType === 5) {
              params.actCode = this.buyObj.actCode;
            }
            this.$router.push({ name: 'paying', query: params });
          } else {
            // 不是实物，直接登录
            this.$router.push({
              name: 'account-selection',
              query: {
                number: this.goodsNum,
                goodsId: this.goodsObj.skuId,
                buyType: this.buyType,
                // appcode 尽量不要用,在分享后的连接带上了会引起重复登录问题
                appCode: this.goodsObj.virtualRights
                  ? this.goodsObj.virtualRights.appCode
                  : undefined,
                // 如果是用户手动点击的拼团,则是新建不要传入groupcode
                groupCode: '',
                preOrderSn: this.preOrderSn,
                actCode: this.buyType === 3 || this.buyType === 5 ? this.buyObj.actCode : ''
              }
            });
          }
        });
    }
  }
};
</script>

<style scoped>
.loading-page-box {
  background-color: #ffffff;
}
.loading-page-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
